var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.images.length ==1)?_c('v-img',{attrs:{"src":_vm.images[0].thumb_md,"aspect-ratio":1}}):_vm._e(),_c(_vm.imageView,{tag:"component",attrs:{"images":_vm.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }